import { render, staticRenderFns } from "./GroupIndex.vue?vue&type=template&id=fd5126d8"
import script from "./GroupIndex.js?vue&type=script&lang=js&external"
export * from "./GroupIndex.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports